// same imports (NO CHANGE)
import React, { useState, useEffect } from "react";
import axios from "axios";
import * as FaIcons from "react-icons/fa";
import { FaTimes, FaBriefcase } from "react-icons/fa";
import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";


const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || import.meta.env.VITE_API_BASE_URL;

const Services = () => {
  const [activeId, setActiveId] = useState(null);
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lang, setLang] = useState(localStorage.getItem("lang") || "en");

  useEffect(() => {
    const handleStorageChange = () => {
      setLang(localStorage.getItem("lang") || "en");
    };
    window.addEventListener("storage", handleStorageChange);
    const interval = setInterval(handleStorageChange, 500);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/services`);
        if (res.data.success) {
          const sortedData = [...res.data.data].sort(
            (a, b) => (a.order || 0) - (b.order || 0),
          );
          setServices(sortedData);
        }
      } catch (err) {
        console.error("Error fetching services:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchServices();
  }, []);

  const rows = [];
  for (let i = 0; i < services.length; i += 3) {
    rows.push(services.slice(i, i + 3));
  }

  if (loading) return null;

  return (
    <div className="transition-all duration-500  text-brand-text font-arial">

     {/* HEADER */}
<section className="relative py-10 text-center bg-white">

  <div className="relative z-10 flex flex-col items-center justify-center text-center max-w-5xl mx-auto">

    {/* LABEL */}
    <span className="text-[#B08D57] uppercase tracking-[0.35em] font-semibold text-[11px] mb-4 block">
      {lang === "en" ? "What We Offer" : "我们提供"}
    </span>

    {/* TITLE */}
    <h1 className="px-4 leading-tight text-[28px] md:text-[36px] font-[Playfair_Display] text-[#1A1A1A] max-w-3xl">
      {lang === "en"
        ? "The right coverage for every part of your life"
        : "为您生活的每一个方面提供合适的保障"}
    </h1>

    {/* DESC */}
    <p className="max-w-3xl mt-6 text-[#999999] text-[14px] md:text-[16px] leading-relaxed px-4">
      {lang === "en"
        ? "Through our relationships with a select group of leading insurers, we offer thoughtful coverage across the areas that matter most. Every recommendation is considered, clearly explained, and carefully placed."
        : "通过与精选领先保险公司的合作，我们在关键领域为您提供周全保障。每一项建议都经过审慎考量、清晰说明，并以专业方式落实。"}
    </p>

  </div>

</section>

   {/* SERVICES */}
<section className="mt-4">
  <div className="container px-6 mx-auto max-w-7xl">
    {rows.map((row, rowIndex) => (
      <div key={rowIndex} className="mb-10">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {row.map((service) => {
            const IconComponent =
              FaIcons[service.iconName] || FaBriefcase;
            const isOpened = activeId === service._id;

            return (
              <React.Fragment key={service._id}>
                <div
                  onClick={() =>
                    setActiveId(isOpened ? null : service._id)
                  }
                  className={`p-10  border cursor-pointer group relative overflow-hidden transition-all duration-500 ${
                    isOpened
                      ? "border-[#B08D57] bg-white scale-[1.02]"
                      : "bg-white border-[#E5E0D8] hover:shadow-[0_20px_50px_rgba(0,0,0,0.08)] hover:-translate-y-1"
                  }`}
                >

                  {/* subtle overlay */}
                  <div className="absolute inset-0 opacity-0 group-hover:opacity-100 transition duration-500 bg-[#B08D57]/5"></div>

                 {/* ICON */}
<div
  className={`w-14 h-14 rounded-full flex items-center justify-center mb-8 transition-all duration-500 ${
    isOpened
      ? "bg-[#B08D57] text-white"
      : "bg-[#1A1A1A] text-white group-hover:bg-[#B08D57]"
  }`}
>
  <IconComponent size={22} />
</div>

                  {/* TITLE */}
                  <h3 className="text-[18px] font-semibold mb-4 text-[#B08D57] font-century">
                    {service.title[lang]}
                  </h3>

                  {/* DESC */}
                  <p className="text-[14px] md:text-[16px] text-[#666666] leading-relaxed mb-8 line-clamp-2">
                    {service.description[lang]}
                  </p>

                  {/* LINK */}
                  <div
                    className={`text-[12px] tracking-wide text-[#B08D57] font-semibold flex items-center gap-2 ${
                      isOpened
                        ? "text-[#B08D57]"
                        : "text-[#999999] group-hover:text-[#B08D57]"
                    }`}
                  >
                    {isOpened
                      ? lang === "en"
                        ? "Close Details"
                        : "关闭详情"
                      : lang === "en"
                      ? "Learn More"
                      : "了解更多"}
                    <ArrowRight
                      size={14}
                      className={`transition-transform duration-300 ${
                        isOpened
                          ? "rotate-90"
                          : "group-hover:translate-x-1"
                      }`}
                    />
                  </div>
                </div>

                {/* MOBILE DETAIL */}
                {isOpened && (
                  <div className="block col-span-1 mt-4 mb-6 md:hidden">
                    <div className="bg-white  border border-[#E5E0D8] p-8 shadow-[0_20px_50px_rgba(0,0,0,0.08)]">
                      <img
                        src={`${API_BASE_URL}${service.image}`}
                        className="object-cover w-full mb-6 h-56 rounded-2xl"
                        alt="Service"
                      />

                      <h4 className="mb-4 text-2xl font-semibold text-[#1A1A1A] font-century">
                        {service.title[lang]}
                      </h4>

                      <p className="text-[14px] text-[#999999]">
                        {service.description[lang]}
                      </p>
<Link
  to="/contact"
  className="block w-full mt-8 text-[12px] uppercase tracking-[0.3em] font-semibold text-[#1A1A1A] hover:text-[#B08D57] transition"
>
  {lang === "en" ? "Request Info" : "申请详情"} →
</Link>
                    </div>
                  </div>
                )}
              </React.Fragment>
            );
          })}
        </div>

        {/* DESKTOP DETAIL */}
        {row.some((s) => s._id === activeId) && (
          <div className="hidden mt-8 md:block">
            {(() => {
              const activeService = services.find(
                (s) => s._id === activeId
              );
              return (
                <div className="bg-white  border border-[#E5E0D8] p-12 shadow-[0_30px_70px_rgba(0,0,0,0.1)] relative">

                  <button
                    onClick={() => setActiveId(null)}
                    className="absolute top-8 right-8 text-[#999999] hover:text-[#B08D57]"
                  >
                    <FaTimes size={20} />
                  </button>

                  <div className="flex flex-col items-center gap-12 lg:flex-row">

                    <div className="lg:w-3/5">

                      <span className="text-[#B08D57] text-[10px] uppercase tracking-[0.4em] font-semibold mb-4 block">
                        {lang === "en" ? "Detailed Overview" : "详细概述"}
                      </span>

                      <h4 className="mb-6 text-3xl font-semibold text-[#1A1A1A] font-century">
                        {activeService.title[lang]}
                      </h4>

                      <p className="text-[14px] md:text-[16px] text-[#999999]">
                        {activeService.description[lang]}
                      </p>

                      <div className="mt-10">
                        <Link
  to="/contact"
  className="text-[12px] uppercase tracking-[0.3em] font-semibold text-[#1A1A1A] hover:text-[#B08D57] transition inline-block"
>
  {lang === "en" ? "Request Consultation" : "咨询建议"} →
</Link>
                      </div>

                    </div>

                    <div className="w-full lg:w-2/5">
                      <img
                        src={`${API_BASE_URL}${activeService.image}`}
                        alt="Service Detail"
                        className="rounded-2xl shadow-lg h-[350px] w-full object-cover"
                      />
                    </div>

                  </div>
                </div>
              );
            })()}
          </div>
        )}
      </div>
    ))}
  </div>
</section>
      {/* CTA */}
<section className="relative pb-10 bg-white">

  <div className="container px-6 mx-auto max-w-6xl">

    {/* CREAM BOX */}
    <div className="bg-[#F5F0E8] p-8 md:p-12 lg:p-14 shadow-sm">

      <div className="flex flex-col gap-10 md:flex-row md:items-center md:justify-between">

        {/* LEFT */}
        <div className="w-full md:w-2/3 text-center md:text-left">

          <h1 className="mb-4 text-[28px] md:text-[34px] font-century text-[#1A1A1A] leading-tight">
            {lang === "en" ? "Not sure" : "不确定"}{" "}
            {lang === "en" ? "what you need?" : "您需要什么？"}
          </h1>

          <p className="text-[14px] md:text-[16px] text-[#666666] max-w-xl leading-relaxed mx-auto md:mx-0">
            {lang === "en"
              ? "That is completely normal, and it is exactly what we are here for. Tell us a little about your situation and we will take it from there."
              : "这完全是很正常的，这也正是我们存在的意义。"}
          </p>

        </div>

        {/* RIGHT CTA */}
        <div className="flex justify-center md:justify-end md:w-1/3">

          <Link 
            to="mailto:juanna@rigors.com.sg"
            className="text-[#1A1A1A] text-[14px] font-semibold tracking-wide group flex items-center gap-2 hover:text-[#B08D57] transition"
          >
            {lang === "en" ? "Request a Consultation" : "预约咨询"}
            <span className="transition-transform duration-300 group-hover:translate-x-1">
              →
            </span>
          </Link>

        </div>

      </div>

    </div>

  </div>

</section>
    </div>
  );
};

export default Services;